import styles from "./Loading.module.scss"
import { usePolyglot } from "src/contexts"

export function Loading() {
  const polyglot = usePolyglot()

  return (
    <div className={styles.loadingContainer}>
      <div className={styles.loadingIcon}>
        {Array.from(Array(5)).map(
          (_, index) => (
            <div
              key={`loading-bar-${index}`}
              className={styles.loadingBar}
              data-index={index}
            />
          ),
        )}
      </div>
      <div
        className={styles.loadingText}
        id="loading"
      >
        {polyglot.t("pages.home.user_header.loading_message")}
      </div>
    </div>
  )
}
